/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {CommonModule} from "@angular/common";
import {NgModule} from "@angular/core";
import {FlexLayoutModule, FlexModule} from "@angular/flex-layout";
import {FormsModule} from "@angular/forms";

import {MatFormFieldModule} from "@angular/material/form-field";
import {MatSelectModule} from "@angular/material/select";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {MatIconModule} from "@angular/material/icon";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatListModule} from "@angular/material/list";
import {MatInputModule} from "@angular/material/input";
import {MatExpansionModule} from "@angular/material/expansion";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatSnackBarModule} from "@angular/material/snack-bar";
import {MatGridListModule} from "@angular/material/grid-list";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {MatDialogModule} from "@angular/material/dialog";
import {MatCardModule} from "@angular/material/card";
import {MatNativeDateModule} from "@angular/material/core";
import {MatButtonModule} from "@angular/material/button";
import {MatTabsModule} from "@angular/material/tabs";
import {MatMenuModule} from "@angular/material/menu";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatTableModule} from '@angular/material/table';
import {MatRadioModule} from "@angular/material/radio";
import {ScrollingModule} from "@angular/cdk/scrolling";

import {AigPipeModule} from "../base/pipes/aig-pipe.module";
import {BaseModule} from "../../platform/base/base.module";
import {BasePipeModule} from "../../platform/base/pipes/base-pipe.module";
import {PostureChartModule} from "../shot/posture-chart/posture-chart.module";
import {VideoTableModule} from "../shot/video-table/video-table.module";
import {PatterTabModule} from "../shot/patter-tab/patter-tab.module";
import {PostureTabModule} from "../shot/posture-tab/posture-tab.module";
import {TrajectoryModule} from "../shot/trajectory/trajectory.module";
import {JudgmentModule} from "../shot/judgment/judgment.module";
import {BallisticTabModule} from "../shot/ballistic-tab/ballistic-tab.module";
import {BallisticChartModule} from "../shot/ballistic-chart/ballistic-chart.module";

import {ShotdataComponent} from "./shotdata.component";
import {ConditionDialogComponent} from "./condition-dialog/condition-dialog.component";
import {ShotdataDialogComponent} from "./shotdata-dialog/shotdata-dialog.component";
import {ShotdataAvgDialogComponent} from "./shotdata-avg-dialog/shotdata-avg-dialog.component";

import {ConfirmCreateShotAvgDialogComponent} from "./confirm-create-shotavg-dialog/confirm-create-shotavg-dialog.component";


import {SessionService} from "../../platform/base/services/session.service";
import {ShotdataService} from "./shotdata.service";
import {MessageDialogModule} from "../base/components/message-dialog/message-dialog.module";

import {ShotModule} from "../shot/shot.module";
import {YesNoDialogModule} from "../../platform/base/components/yes-no-dialog/yes-no-dialog.module";
import {DescriptionDialogComponent} from "./description-dialog/description-dialog.component";
import {HoverClassDirective} from './hover-class.directive';
import {MatPaginatorIntl} from '@angular/material/paginator';
import { NgxLinkifyjsModule } from "ngx-linkifyjs";


// i18n
import {TranslateModule} from "@ngx-translate/core";
import {MatPaginationIntlService} from "../base/services/i18n-pagenator.service";

//
@NgModule({
	declarations: [
		ShotdataComponent,
		ConditionDialogComponent,
		ShotdataDialogComponent,
        ShotdataAvgDialogComponent,
        ConfirmCreateShotAvgDialogComponent,
		DescriptionDialogComponent,
		HoverClassDirective
	],
	providers: [
		SessionService,
		ShotdataService,
		{provide: MatPaginatorIntl, useClass: MatPaginationIntlService}
	],
    imports: [
        CommonModule,
        FormsModule,
        ScrollingModule,
		NgxLinkifyjsModule.forRoot(),

        FlexModule,
        FlexLayoutModule,

        MatDialogModule,
        MatCardModule,
        MatIconModule,
        MatButtonModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatInputModule,
        MatListModule,
        MatCheckboxModule,
        MatSelectModule,
        MatSnackBarModule,
        MatFormFieldModule,
        MatExpansionModule,
        MatAutocompleteModule,
        MatProgressSpinnerModule,
        MatPaginatorModule,
        MatSlideToggleModule,
        MatGridListModule,
        MatTabsModule,
        MatMenuModule,
        MatTooltipModule,
        MatTableModule,
        MatRadioModule,

        BaseModule,

        BasePipeModule,
        AigPipeModule,
        MessageDialogModule,
        YesNoDialogModule,
        PostureChartModule,
        VideoTableModule,
        PatterTabModule,
        PostureTabModule,
        TrajectoryModule,
        JudgmentModule,
        BallisticTabModule,
        BallisticChartModule,
        ShotModule,
        TranslateModule
    ],
	exports: [
		ShotdataComponent,
	],
	bootstrap: [
		ShotdataDialogComponent,
        ShotdataAvgDialogComponent,
		DescriptionDialogComponent,
		ConditionDialogComponent,
		DescriptionDialogComponent
	],
})

export class ShotdataModule {
}
